import { produce } from 'immer';

import type { BookingValueLimit } from '@/types/booked-bet';
import { OperationType } from '@/types/booked-bet';
import { IncDecType } from '@nf/utils-common/constants';
import BookingValueBloc from './booking-value-bloc';
import BookingManager from '../services/booking-strategies/booking-manager';
import MainBookingStrategy from '../services/booking-strategies/main-booking-strategy';
import CsBookingStrategy from '../services/booking-strategies/cs-booking-strategy';

class OddsValueBloc extends BookingValueBloc {
	configureStrategy() {
		const bookingStrategy = this.info.isFixedDecimal 
			? new CsBookingStrategy(this.bookingOptions, this.info)
			: new MainBookingStrategy(this.bookingOptions, this.info);
		this.bookingManager = new BookingManager(bookingStrategy);
	}

	public plus(): void {
		this._bookingValue$.next(
			produce(this._bookingValue$.getValue(), draft => {
				const value = this.bookingManager.calculateBookingOdds(draft.expectedValue, OperationType.Plus);
				this.checkAndResetBookingValueError(draft, value);
			})
		);
	}

	public minus(): void {
		this._bookingValue$.next(
			produce(this._bookingValue$.getValue(), draft => {
				const value = this.bookingManager.calculateBookingOdds(draft.expectedValue, OperationType.Minus);
				this.checkAndResetBookingValueError(draft, value);
			})
		);
	}

	public calculateDefaultIncrementedLimit(value: number): BookingValueLimit {
		return this.bookingManager.calculateDefaultLimit(value, IncDecType.Increment);
	}

	public calculateDefaultDecrementedLimit(value: number): BookingValueLimit {
		return this.bookingManager.calculateDefaultLimit(value, IncDecType.Decrement);
	}
}

export default OddsValueBloc;